import { each, go } from 'fxjs/es';
import { $findAll } from 'fxdom/es';
import { drawThumbnail, drawUpscalingThumbnail } from './drawThumbnail.js';

export const pRenderCanvas = (el) => {
  go(
    el,
    $findAll('.up-item-thumbnail'),
    each((product_face_el) => {
      drawThumbnail(product_face_el);
    }),
  );
};

export const pRenderUpscalingCanvas = (el) => {
  go(
    el,
    $findAll('.up-item-thumbnail'),
    each((product_face_el) => {
      drawUpscalingThumbnail(product_face_el);
    }),
  );
};
